import React, { useEffect, useState } from "react";
import "./Admin.css";
import AdminSidebar from "./comon/AdminSidebar";
import Header from "./comon/Header";

import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Input,
  FormGroup,
  Label,
  Button,
  Table,
} from "reactstrap";

import {
  MdDelete,
  MdAddCircle,
  MdQuiz,
  MdCategory,
} from "react-icons/md";

function QuestionMaster() {
  const [qus, setQus] = useState("");
  const [catType, setcatType] = useState("");
  const [qusList, setQusList] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadQuestions = () => {
    fetch("https://idverify.emphasispay.com/api/get-qus-list.php")
      .then((rs) => rs.json())
      .then((resul) => {
        setQusList(resul.result || []);
      });
  };

  const saveQus = () => {
    if (!qus) return;

    setLoading(true);

    fetch("https://idverify.emphasispay.com/api/save-qus.php", {
      method: "POST",
      body: JSON.stringify({
        qus: qus,
        category: catType,
      }),
    })
      .then((res) => res.json())
      .then(() => {
        setQus("");
        setcatType("");
        loadQuestions();
        setLoading(false);
      });
  };

  useEffect(() => {
    loadQuestions();
  }, []);

  return (
    <div className="main-div">
      <AdminSidebar />

      <div className="fill-width">
        <Header />

        <div className="dashboard-container">

          {/* Top */}
          <div className="page-top-box">
            <div>
              <h2>Question Master</h2>
              <p>Manage interview questions and categories.</p>
            </div>

            <div className="user-count-box purple-box">
              <MdQuiz />
              <span>{qusList.length} Questions</span>
            </div>
          </div>

          <Row>

            {/* Left Form */}
            <Col md={5}>
              <Card className="table-card">
                <CardHeader className="table-header">
                  <h4>Add New Question</h4>
                </CardHeader>

                <CardBody>

                  <FormGroup>
                    <Label className="label-white">
                      <MdCategory /> Category Type
                    </Label>

                    <Input
                      className="dark-input"
                      type="text"
                      placeholder="Enter category..."
                      value={catType}
                      onChange={(e) => setcatType(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label className="label-white">
                      <MdQuiz /> Add Question
                    </Label>

                    <Input
                      className="dark-input"
                      type="textarea"
                      rows="5"
                      placeholder="Write question here..."
                      value={qus}
                      onChange={(e) => setQus(e.target.value)}
                    />
                  </FormGroup>

                  <Button
                    className="add-btn"
                    block
                    onClick={saveQus}
                    disabled={loading}
                  >
                    <MdAddCircle />
                    {loading ? " Saving..." : " Add Question"}
                  </Button>

                </CardBody>
              </Card>
            </Col>

            {/* Right List */}
            <Col md={7}>
              <Card className="table-card">
                <CardHeader className="table-header">
                  <h4>Question List</h4>
                </CardHeader>

                <CardBody className="p-0">

                  <div className="table-responsive">
                    <Table className="modern-table" borderless hover>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Question</th>
                          <th width="100">Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {qusList.length > 0 ? (
                          qusList.map((item, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>

                              <td>{item.qus}</td>

                              <td>
                                <Button
                                  size="sm"
                                  className="delete-btn"
                                >
                                  <MdDelete />
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center p-4">
                              No Questions Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                </CardBody>
              </Card>
            </Col>

          </Row>

        </div>
      </div>
    </div>
  );
}

export default QuestionMaster;